export default {
  config: {
    id: process.env.VUE_APP_GA_MEASUREMENT_ID,
  },
};
